import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'usernameInitials',
  standalone: false,
})
export class UsernameInitialsPipe implements PipeTransform {
  transform(username: string, numChars: number): string {
    return username
      .split(' ')
      .slice(0, numChars)
      .map(n => n[0].toUpperCase())
      .join('');
  }
}
